import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Calendar, MapPin, User, Mail, Hash, Award, ArrowLeft } from 'lucide-react';
import axios from 'axios';
import { useTheme } from '../context/ThemeContext';
import API_URL from '../api';

function MyTicket() {
  const { registrationId } = useParams();
  const navigate = useNavigate();
  const [reg, setReg] = useState(null);
  const [error, setError] = useState('');
  const { darkMode } = useTheme();

  const bg = darkMode ? '#0f0f1a' : '#f0f2f5';
  const card = darkMode ? '#1a1a2e' : '#fff';
  const border = darkMode ? 'rgba(255,255,255,0.07)' : '#f0f0f0';
  const text = darkMode ? '#e0e0e0' : '#333';
  const subtext = darkMode ? '#888' : '#666';

  useEffect(() => {
    axios.get(`${API_URL}/api/registrations/${registrationId}`)
      .then(res => setReg(res.data))
      .catch(err => setError(err.response?.data?.error || err.message));
  }, [registrationId]);

  if (error) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', background: bg }}>
      <div style={{ textAlign: 'center', color: '#e94560' }}>
        <h2>❌ {error}</h2>
        <button onClick={() => navigate('/my-tickets')} style={{ marginTop: '15px', background: '#e94560', color: '#fff', padding: '10px 20px', borderRadius: '8px' }}>Back to Tickets</button>
      </div>
    </div>
  );

  if (!reg) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', background: bg }}>
      <div style={{ width: '40px', height: '40px', border: '3px solid #e94560', borderTop: '3px solid transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  return (
    <div style={{ background: bg, minHeight: '100vh', padding: '30px 20px' }}>
      <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }`}</style>
      <div style={{ maxWidth: '500px', margin: '0 auto' }}>
        <button onClick={() => navigate('/my-tickets')} style={{ background: 'transparent', color: subtext, display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '20px', padding: '0', fontSize: '14px' }}>
          <ArrowLeft size={16} /> Back to My Tickets
        </button>
        <div style={{ background: card, borderRadius: '24px', overflow: 'hidden', border: `1px solid ${border}`, boxShadow: darkMode ? '0 8px 40px rgba(0,0,0,0.4)' : '0 8px 40px rgba(0,0,0,0.1)' }}>
          <div style={{ background: 'linear-gradient(135deg, #1a1a2e, #0f3460)', padding: '30px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: '-30px', right: '-30px', width: '120px', height: '120px', background: 'rgba(233,69,96,0.15)', borderRadius: '50%' }} />
            <div style={{ position: 'absolute', bottom: '-20px', left: '-20px', width: '80px', height: '80px', background: 'rgba(255,255,255,0.05)', borderRadius: '50%' }} />
            <span style={{ background: 'rgba(233,69,96,0.2)', color: '#e94560', padding: '5px 15px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', display: 'inline-block', marginBottom: '12px' }}>🎟️ EVENT TICKET</span>
            <h1 style={{ color: '#fff', fontSize: '22px', fontWeight: '700', marginBottom: '5px' }}>{reg.eventId?.title || 'Event'}</h1>
            <p style={{ color: '#aaa', fontSize: '14px' }}>Show this QR code at the entry gate</p>
          </div>
          <div style={{ padding: '30px', textAlign: 'center', borderBottom: `2px dashed ${border}` }}>
            <div style={{ background: '#fff', borderRadius: '16px', padding: '15px', display: 'inline-block', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
              <img src={reg.qrCode} alt="QR Code" style={{ width: '180px', height: '180px', display: 'block' }} />
            </div>
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
              <div style={{ background: darkMode ? 'rgba(233,69,96,0.1)' : '#fff5f7', border: '1px solid rgba(233,69,96,0.2)', borderRadius: '12px', padding: '12px 20px', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                <Award size={18} color="#e94560" />
                <span style={{ color: '#e94560', fontWeight: '700', fontSize: '16px' }}>Queue Position #{reg.queuePosition}</span>
              </div>
            </div>
          </div>
          <div style={{ padding: '25px' }}>
            <h3 style={{ color: text, marginBottom: '15px', fontSize: '15px', fontWeight: '600' }}>Ticket Details</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                { icon: <User size={15} color="#e94560" />, label: 'Name', value: reg.name },
                { icon: <Mail size={15} color="#e94560" />, label: 'Email', value: reg.email },
                { icon: <Hash size={15} color="#e94560" />, label: 'Roll No', value: reg.rollNo || 'N/A' },
                { icon: <Calendar size={15} color="#e94560" />, label: 'Date', value: reg.eventId?.date ? new Date(reg.eventId.date).toDateString() : 'N/A' },
                { icon: <MapPin size={15} color="#e94560" />, label: 'Venue', value: reg.eventId?.venue || 'N/A' },
              ].map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', background: darkMode ? 'rgba(255,255,255,0.03)' : '#f8f8f8', borderRadius: '10px' }}>
                  {item.icon}
                  <div>
                    <p style={{ color: subtext, fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{item.label}</p>
                    <p style={{ color: text, fontSize: '14px', fontWeight: '500', marginTop: '2px' }}>{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ marginTop: '20px', padding: '14px', borderRadius: '12px', textAlign: 'center', background: reg.checkedIn ? (darkMode ? 'rgba(76,175,80,0.15)' : '#e8f5e9') : (darkMode ? 'rgba(255,152,0,0.15)' : '#fff8f0'), border: `1px solid ${reg.checkedIn ? 'rgba(76,175,80,0.3)' : 'rgba(255,152,0,0.3)'}` }}>
              <span style={{ color: reg.checkedIn ? '#4caf50' : '#ff9800', fontWeight: '700', fontSize: '15px' }}>
                {reg.checkedIn ? '✅ Checked In' : '⏳ Not checked in yet'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyTicket;